import React, { useEffect, useRef, useState } from 'react';
import { AppData, ModuleData } from '../../types/appTypes';
import Topbar from './Topbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import WebTableView from '../content/WebTableView';
import "./layout.css"
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { Message } from 'primereact/message';
import { InputTextarea } from 'primereact/inputtextarea';
import { fetchBlobToken, fetchModules, uploadAppVersion } from '../../services/api';
import { Toast } from 'primereact/toast'
import Loader from '../Loader/Loader';

// type Props = { data: AppData[]; isAdmin: boolean; email: string };

type Props = { data: ModuleData[]; isAdmin: boolean; email: string };

const releaseTypes = [
    { label: 'China', value: 'china' },
    { label: 'UAT', value: 'uat' },
    { label: 'QA', value: 'qa' }
];

const dummyAlternatives = [
    { label: 'WhatsApp', value: 'whatsapp' },
    { label: 'Facebook', value: 'facebook' },
    { label: 'Instagram', value: 'instagram' }
];

const AddNewAppModal: React.FC<{ onClose: () => void, setisLoading: React.Dispatch<React.SetStateAction<boolean>>, email: string }> = ({ onClose, setisLoading, email }) => {
    const [appName, setAppName] = useState('');
    const [releaseType, setReleaseType] = useState('');
    const [releaseVersion, setVersion] = useState('');
    const [releaseDescription, setAppDescription] = useState('');
    const [file, setFile] = useState<File | null>(null);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [modules, setModules] = useState<{ appName: string; appId: string }[]>([]);
    const [loadingModules, setLoadingModules] = useState(false);
    const toast = useRef<Toast>(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoadingModules(true);
            try {
                const data = await fetchModules();
                setModules(
                    data.content.map((item: any) => ({
                        appId: String(item.appId),
                        appName: item.appName,
                        imageDetail: item.imageDetail
                    }))
                );
            } catch (error) {
                console.error('Failed to fetch modules:', error);
            } finally {
                setLoadingModules(false);
            }
        };
        fetchData();
    }, []);

    const validate = () => {
        const newErrors: { [key: string]: string } = {};
        if (!appName) newErrors.appName = 'App Name is required';
        if (!releaseVersion) newErrors.releaseVersion = 'Version is required';
        if (!releaseDescription) newErrors.releaseDescription = 'Release Description is required';
        else if (releaseDescription.split('\n').length > 2) newErrors.releaseDescription = 'Max 2 lines allowed';
        if (!file) newErrors.file = 'APK file is required';
        else if (!file.name.endsWith('.apk')) newErrors.file = 'Only .apk files are allowed';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0] || null;
        setFile(selectedFile);
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validate()) return;
        const postData = {
            appId: appName,
            releaseVersion,
            releaseDescription,
            releaseDate: Date.now(), // timestamp in milliseconds
            fileName: releaseVersion + '.apk',
            active: 1
        };

        if (toast.current) {
            toast.current.show({
                severity: 'warn',
                summary: 'warn',
                detail: `"Uploading the APK may take a few moments. Please wait until the process is complete."`,
                life: 2000,
            });
        }
        onClose();
        setisLoading(true);
        const blob = await fetchBlobToken(postData.appId, postData.fileName, file ?? undefined);
        if (blob && 'success' in blob && blob.success) {
            const uploadApp = await uploadAppVersion(postData, email);
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'success',
                    detail: `App Submitted Successfully`,
                    life: 2000,
                });
            }
        }
        setisLoading(false);
        // window.location.reload();
    };

    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'row', gap: 24, alignItems: 'flex-start' }}>
                {/* Left: Icon */}
                {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 8 }}>
                    <i className="pi pi-android" style={{ fontSize: 48, color: '#2D6DF6' }} />
                </div> */}
                {/* Right: Form Fields */}
                <div style={{ flex: 1 }}>
                    {/* App Name and App Alternatives side by side */}
                    <div className='mb-4 w-full' style={{ display: 'flex', gap: 16 }}>
                        {/* App Name */}
                        {/* <div style={{ flex: 1 }}>
                        <label className='block text-sm font-medium mb-1'>App Name</label>
                        <InputText
                            className='w-full'
                            value={appName}
                            onChange={e => {
                                setAppName(e.target.value);
                                if (errors.appName) setErrors(prev => {
                                    const { appName, ...rest } = prev;
                                    return rest;
                                });
                            }}
                            placeholder='Enter app name'
                        />
                        {errors.appName && <Message severity="error" text={errors.appName} />}
                    </div> */}
                        {/* App Alternatives */}
                        {/* <div style={{ flex: 1 }}>
                        <label className='block text-sm font-medium mb-1'>App Alternatives</label>
                        <Dropdown
                            className='w-full'
                            value={appName}
                            options={dummyAlternatives}
                            onChange={e => setAppName(e.value)}
                            placeholder="Select Alternative"
                        />
                        {errors.appName && <Message severity="error" text={errors.appName} />}

                    </div> */}
                    </div>
                    {/* Release Type and Version side by side */}
                    <div className='mb-4 w-full' style={{ display: 'flex', gap: 16 }}>
                        {/* Release Type */}
                        {/* <div style={{ flex: 1 }}>
                        <label className='block text-sm font-medium mb-1'>Release Type</label>
                        <Dropdown
                            className='w-full'
                            value={releaseType}
                            options={releaseTypes}
                            onChange={e => {
                                setReleaseType(e.value);
                                if (errors.releaseType) setErrors(prev => {
                                    const { releaseType, ...rest } = prev;
                                    return rest;
                                });
                            }}
                            placeholder="Select Release Type"
                        />
                        {errors.releaseType && <Message severity="error" text={errors.releaseType} />}
                    </div> */}
                        <div style={{ flex: 1 }}>
                            <label className='block text-sm font-medium mb-1'>App Name</label>
                            <Dropdown
                                className='w-full'
                                value={appName}
                                options={modules.map(m => ({ label: m.appName, value: m.appId }))}
                                onChange={e => {
                                    setAppName(e.value);
                                    if (errors.appName) setErrors(prev => {
                                        const { appName, ...rest } = prev;
                                        return rest;
                                    });
                                }}
                                placeholder="Select App"
                                loading={loadingModules}
                            />
                            {errors.appName && <Message severity="error" text={errors.appName} />}

                        </div>
                        {/* Version */}
                        <div style={{ flex: 1 }}>
                            <label className='block text-sm font-medium mb-1'>Version</label>
                            <InputText
                                className='w-full'
                                value={releaseVersion}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setVersion(e.target.value);
                                    if (errors.releaseVersion) setErrors(prev => {
                                        const { releaseVersion, ...rest } = prev;
                                        return rest;
                                    });
                                }}
                                placeholder='Enter release Version'
                            />
                            {errors.releaseVersion && <Message severity="error" text={errors.releaseVersion} />}
                        </div>
                    </div>
                    <div className='mb-4 w-full' style={{ display: 'flex', gap: 16 }}>
                        {/* Release Description */}
                        <div style={{ flex: 1 }}>
                            <label className='block text-sm font-medium mb-1'>Release Description</label>
                            <InputTextarea
                                className='w-full'
                                value={releaseDescription}
                                onChange={e => {
                                    setAppDescription(e.target.value);
                                    if (errors.releaseDescription) setErrors(prev => {
                                        const { releaseDescription, ...rest } = prev;
                                        return rest;
                                    });
                                }}
                                placeholder='Enter Release Description'
                                rows={2}
                                autoResize
                                maxLength={200}
                                style={{ minHeight: 38, maxHeight: 60, overflow: 'auto', whiteSpace: 'pre-line' }}
                            />
                            {errors.releaseDescription && <Message severity="error" text={errors.releaseDescription} />}
                        </div>
                    </div>
                    {/* Upload app - only .apk */}
                    <div className='mb-4 w-full'>
                        <label className='block text-sm font-medium mb-1'>Upload App (.apk only)</label>
                        <input
                            type="file"
                            accept=".apk"
                            className='w-full p-2 border rounded'
                            onChange={handleFileChange}
                        />
                        {errors.file && <Message severity="error" text={errors.file} />}
                    </div>
                    {/* Submit Button */}
                    <div className='flex justify-end'>
                        <Button
                            type="submit"
                            label="Submit"
                            style={{ backgroundColor: '#2D6DF6', color: 'white' }}
                        />
                    </div>
                </div>
            </form>
        </>

    );
};

const WebLayout: React.FC<Props> = ({ data, isAdmin, email }) => {
    const [showModal, setShowModal] = useState(false);
    const toast = useRef<Toast>(null);
    const [isLoading, setisLoading] = useState(false);


    return (
        <>
            <Toast ref={toast} />

            <Topbar isAdmin={isAdmin} email={email} />

            <Dialog
                className="custom-dialog"
                header="Add New App"
                visible={showModal}
                contentStyle={{ width: '56vw', alignItems: 'unset', justifyContent: 'unset' }}
                style={{ width: '56vw', alignItems: 'unset', justifyContent: 'unset' }}
                onHide={() => setShowModal(false)}
                closable
                draggable={false}
                resizable={false}
                closeIcon={
                    <i
                        className="pi pi-times"
                        style={{ color: 'white', fontSize: 20, cursor: 'pointer' }}
                        onMouseEnter={e => (e.currentTarget.style.color = 'black')}
                        onMouseLeave={e => (e.currentTarget.style.color = 'white')}
                    />
                }
            >
                <AddNewAppModal onClose={() => setShowModal(false)} setisLoading={setisLoading} email={email} />
            </Dialog>
            {isAdmin && (
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '0.5rem', marginTop: '0.25rem', marginRight: '1rem' }}>
                    <Button
                        style={{
                            backgroundColor: '#2D6DF6',
                            color: 'white',
                            fontSize: '0.85rem',
                            padding: '0.25rem 0.75rem',
                            height: '2rem'
                        }}
                        label="Add New"
                        icon="pi pi-plus"
                        iconPos="left"
                        onClick={() => setShowModal(true)}
                    />
                </div>
            )}
            {isLoading ? (<Loader />) : (
                <WebTableView data={data} />

            )}
        </>
    );
};

export default WebLayout;
